import {
  GenerateProjectAssignmentTemplateRequestBody,
  CancelDocumentRequestBody,
  CreateCSAEmbeddedRequestBody,
  GenerateCSADocumentRequestBody,
  ProcessCSAPreparationRequestBody,
  UploadTemplateRequestBody,
  ViewTemplateRequestQuery,
  ProcessSignedTaxFormRequestBody,
  GenerateReplacementTaxFormRequestBody,
  TaxFormResponse,
  EversignDocumentRequestBody,
  FetchEversignTemplatesOutput,
  EversignDocumentResponse,
} from "@freetech/models/eversign";
import { axiosClient } from "../axiosClient";

export const eversign = {
  admin: {
    generateProjectAssignment: async (
      input: GenerateProjectAssignmentTemplateRequestBody
    ): Promise<any> => {
      return await axiosClient.post(
        "/eversign/admin/generate-project-assignment",
        input
      );
    },
    fetchTemplates: async (): Promise<FetchEversignTemplatesOutput> => {
      return await axiosClient.get("/eversign/admin/fetch-templates");
    },
    viewTemplate: async (
      templateHash: string,
      sandbox?: boolean
    ): Promise<any> => {
      return await axiosClient.get("/eversign/admin/view-template", {
        params: {
          template_hash: templateHash,
          sandbox: sandbox?.toString() || "false",
        },
      });
    },
    useTemplate: async ({
      documentData,
      sandbox,
    }: {
      documentData: EversignDocumentRequestBody;
      sandbox: number;
    }): Promise<EversignDocumentResponse> => {
      return await axiosClient.post("/eversign/admin/use-template", {
        document_data: documentData,
        sandbox,
      });
    },
    generateCSA: async (
      input: GenerateCSADocumentRequestBody
    ): Promise<any> => {
      return await axiosClient.post("/eversign/admin/generate-csa", input);
    },
    cancelDocument: async (
      documentHash: string
    ): Promise<{ success: boolean; message?: string }> => {
      const requestBody: CancelDocumentRequestBody = {
        document_hash: documentHash,
      };
      return await axiosClient.post(
        "/eversign/admin/cancel-document",
        requestBody
      );
    },
    createCSAEmbeddedRequest: async (
      input: CreateCSAEmbeddedRequestBody
    ): Promise<any> => {
      return await axiosClient.post(
        "/eversign/admin/csa-embedded-request",
        input
      );
    },
    processCSAPreparation: async (
      input: ProcessCSAPreparationRequestBody
    ): Promise<{ success: boolean; message?: string }> => {
      return await axiosClient.post(
        "/eversign/admin/process-csa-preparation",
        input
      );
    },
    uploadTemplate: async (
      templateData: UploadTemplateRequestBody
    ): Promise<any> => {
      return await axiosClient.post(
        "/eversign/admin/upload-template",
        templateData
      );
    },
  },

  freelancer: {
    generateW9Form: async (): Promise<TaxFormResponse> => {
      return await axiosClient.get("/eversign/freelancer/generate-w9-form");
    },
    generateW8BenForm: async (): Promise<TaxFormResponse> => {
      return await axiosClient.get("/eversign/freelancer/generate-w8ben-form");
    },
    generateReplacementTaxForm: async (
      input: GenerateReplacementTaxFormRequestBody
    ): Promise<TaxFormResponse> => {
      return await axiosClient.post(
        "/eversign/freelancer/generate-replacement-tax-form",
        input
      );
    },
  },
};
